import type { OptionType } from 'types/OptionType'

export type ContactLike = { id?: string | null; name?: string | null; locationId?: string | null }

/** A contact as a picker option, with its location's name as the subtext. */
export function createContactOption(
  contact: ContactLike,
  locations: readonly { id?: string; name?: string | null }[],
): OptionType {
  const locationName = locations.find((loc) => loc.id === contact.locationId)?.name ?? undefined
  return {
    id: contact.id!,
    name: contact.name!,
    value: contact.id!,
    meta: {
      nameInitial: true,
      subtext: locationName,
      locationId: contact.locationId!,
    },
  }
}
